import codingIcon from '../assets/icons/coding.png';
import ecologyIcon from '../assets/icons/ecology.png';
import sketchIcon from '../assets/icons/sketch.png';

import type { Service } from './types/service';

export const services: Service[] = [
  {
    id: 'custom-software',
    icon: sketchIcon,
    alt: 'Custom Software Systems',
    title: 'Custom Software Systems',
    description:
      'Ounic designs and develops custom systems, internal tools, and AI-powered platforms used by teams to automate workflows, manage operations, and deliver reliable products.',
  },
  {
    id: 'ai-automation',
    icon: codingIcon,
    alt: 'AI & Workflow Automation',
    title: 'AI & Workflow Automation',
    description:
      'Ounic develops AI-powered tools that automate repetitive processes, process data, and improve operational efficiency across teams.',
  },
  {
    id: 'platforms-applications',
    icon: ecologyIcon,
    alt: 'Platforms & Applications',
    title: 'Platforms & Applications',
    description:
      'Ounic builds scalable web and mobile applications — from MVPs to full production systems used by customers and internal teams.',
  },
];
